import React, { FC, PropsWithChildren, useContext } from "react"

import AuthDescriptorContext from "./Context"

const CruiseLineOnly: FC<PropsWithChildren> = ({ children }) => {
  const { isCruiseLineUi } = useContext(AuthDescriptorContext)

  if (!isCruiseLineUi) {
    return null
  }

  return <>{children}</>
}

export default CruiseLineOnly
